import { colorsPalettes } from "@similarweb/styles";

import type { IDeviceDistributionChartData } from "../../../../../types";
import type { IDeviceDistributionPieChartSeries } from "../types";

import { chartConfig } from "./chartConfig";

export const getPieChartConfig = (onMouseOverChart: (event: any) => void, onMouseOutChart: (event: any) => void) => {
    return chartConfig({
        type: "pie",
        onMouseOverChart,
        onMouseOutChart,
    });
};

export const getPieChartStyle = () => {
    return {
        style: {
            height: "auto",
        },
    };
};

export const adaptPieChartDataRecords = (data: IDeviceDistributionChartData): IDeviceDistributionPieChartSeries[] => {
    const { mobileWeb, desktop } = data;
    const totalSum = mobileWeb + desktop;

    const records = [
        {
            color: colorsPalettes.sky[500],
            name: "Desktop",
            seriesName: "Desktop",
            y: (desktop / totalSum) * 100,
        },
        {
            color: colorsPalettes.sky[300],
            name: "Mobile Web",
            seriesName: "Mobile Web",
            y: (mobileWeb / totalSum) * 100,
        },
    ];

    return records;
};
